import React, { FC } from 'react';
import { t } from '../../../../../utils/helpers';
import coin from '../../../../../assets/images/coin.png';
import { Avatar } from '../../../../avatar/components/avatar';
import { IPlayer } from '@base/features/player/model/interfaces';
import PopoverPlayerAdditionalInfo from '../../../../playerAdditionalInfo/popoverPlayerAdditionalInfo/popoverPlayerAdditionalInfo';

type PropsType = {
  players: IPlayer[];
  currentUser: string;
  children?: never;
  selectedPlayers?: number[];
  onChange?: (pid: number) => void;
};

export const OnlinePlayersList: FC<PropsType> = ({ players, selectedPlayers, onChange }: PropsType) => {
  return (
    <div className="online-players__content">
      {players.map((player: IPlayer) => (
        <OnlinePlayer
          key={player.pid}
          player={player}
          selectedPlayers={selectedPlayers}
          onChange={onChange}
        />
      ))}
    </div>
  );
};

function OnlinePlayer(props: {
  player: IPlayer;
  selectedPlayers?: number[];
  onChange?: (pid: number) => void;
}) {
  const { player, selectedPlayers, onChange } = props;
  return (
    <PopoverPlayerAdditionalInfo placement="left" key={player.pid} player={player}>
      <div
        className={`online-players__content-item
          ${selectedPlayers?.includes(player.pid) && 'online-players__content-item__invite--selected'}
          ${selectedPlayers && 'online-players__content-item__invite'}`}
        key={player.pid}
        onClick={() => onChange?.(player.pid)}
      >
        <div className="online-players__user-card">
          <Avatar classes="online-players__content-avatar" player={player} />
          <div className="online-players__content-username">
            {player.name}
            {player.isTicketPlayer() ? (
              <img className="messages__author-ticket" src={coin} alt="ticket" />
            ) : null}
          </div>
        </div>
        <div className="online-players__content-rating">{player.rating}</div>
        <div
          className={`online-players__content-status--${player.getStatus()} online-players__content-status`}
        >
          {t(player.getStatus())}
        </div>
      </div>
    </PopoverPlayerAdditionalInfo>
  );
}
